export default __webpack_public_path__ + "static/media/border-radius-top-left.1571f0ce.svg";